module.exports = __webpack_public_path__ + "static/media/release_06.60d0a048.png";